/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { OutboundLink, routes } from 'gatsby-theme-apollo';
import EntityThumbnail from '../entities/entity-thumbnail';

const subtleGrow = keyframes`
  0% {
    transform: scale(1);
  }

  50%{
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
`;

const TierViewEntityThumbnailRoot = styled(OutboundLink)(props => ({
  margin: props.size.margin,
  borderRadius: `5px`,
  transition: `border 0.2s ease, transform 0.1s`,
  cursor: `pointer`,
  animation: `${props => (props.wiggling ? subtleGrow : 'none')} .5s ease}`,
  animationDuration: `1s infinite`,
  [`:hover`]: {
    border: `1px solid ${props.theme.primary}`
  },
  border:
    props.activeFiltering && !props.isFilteredOut ? `1px solid white` : `1px solid transparent`
}));

export const TierViewEntityThumbnail = ({
  character,
  stats,
  highlights,
  gameStats,
  gameName,
  entityTypePlural,
  activeFiltering,
  isFilteredOut,
  logEditorEvent,
  size
}) => {
  const checkStatAndAddBadge = (gameStat, statValue, badgeIcons) => {
    const statIconConfig =
      gameStat.options && gameStat.options.find(option => option.name === statValue);
    if (statIconConfig) {
      badgeIcons.push({
        uri: statIconConfig.uri
      });
    }
  };

  const colorStat = highlights && highlights.filterStat;
  let highlightColor;

  if (colorStat) {
    const thisCharacterColorStatName = stats && stats[colorStat.name];
    const ColorStatConfig = gameStats.find(stat => stat.name === colorStat.name);

    const characterColorConfig =
      ColorStatConfig &&
      ColorStatConfig.options.find(statConfig => statConfig.name === thisCharacterColorStatName);

    if (characterColorConfig && characterColorConfig.color) {
      highlightColor = characterColorConfig.color;
    }
  }

  const badgeIcons = [];

  if (gameStats) {
    gameStats.forEach(gameStat => {
      if (gameStat.visualType === 'icon') {
        const statKey = gameStat.name;
        const thisCharacterStatValue = stats && stats[statKey];
        if (thisCharacterStatValue) {
          const statHasMultipleValues = Array.isArray(thisCharacterStatValue);
          if (!statHasMultipleValues) {
            checkStatAndAddBadge(gameStat, thisCharacterStatValue, badgeIcons);
          }
          if (statHasMultipleValues) {
            thisCharacterStatValue.forEach(statValue => {
              checkStatAndAddBadge(gameStat, statValue, badgeIcons);
            });
          }
        }
      }
    });
  }

  const destinationURL =
    gameName && routes.Entity(gameName, entityTypePlural, character.name);

  var thumbnailProps = {
    name: character.name,
    size,
    isFilteredOut,
    badgeIcons,
    highlightColor,
    imgSrc: character.thumbnailURI
  };

  return (
    <TierViewEntityThumbnailRoot
      onClick={() => {
        if (logEditorEvent) {
          logEditorEvent('entity_thumbnail_navigate', {
            entityName: character.name,
            destinationURL
          });
        }
      }}
      size={size}
      activeFiltering={activeFiltering}
      isFilteredOut={isFilteredOut}
      href={destinationURL}
      target={gameName && '_blank'}
      title={`More info on ${character.name}`}
    >
      <EntityThumbnail {...thumbnailProps} />
    </TierViewEntityThumbnailRoot>
  );
};